import { render, staticRenderFns } from "./PmtaRelayGroupForm.vue?vue&type=template&id=117ff380&scoped=true"
import script from "./PmtaRelayGroupForm.vue?vue&type=script&lang=js"
export * from "./PmtaRelayGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ff380",
  null
  
)

export default component.exports